module.exports = __webpack_public_path__ + "static/media/yale.60ffacd4.png";